import React from 'react';
import styles from './snipe.module.css';
import { Snipe as SnipeProp } from '../../typescript/component';
import Button from './button';

export default function Snipe({ snipe }: { snipe: SnipeProp }) {
  return (
    <>
      {snipe && snipe.title && (
        <div className={styles.snipe}>
          <section className={styles.container}>
            <div className={styles.content}>
              <h3 className={styles.title}>{snipe.title}</h3>
              <span
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: snipe.description }}
              />
            </div>
            {snipe && snipe.cta && snipe.title && snipe.cta.href && (
              <Button
                text={snipe.cta.title}
                showIcon
                propWidth="250px"
                propBorderColor="var(--white)"
                propBackgroundColor="transparent"
                propHoverBackgroundColor="var(--white)"
                propHoverText="var(--charcoal-500)"
                propTextColor="var(--white)"
                link={snipe.cta.href}
              />
            )}
          </section>
        </div>
      )}
    </>
  );
}
